module.exports = __webpack_public_path__ + "img/SW_Stylized sword_2.e93e05b5.png";